import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "title-1 text-grey-900 pt-0 pt-lg-4" }
const _hoisted_3 = { class: "pt-2 layout" }



  
export default /*@__PURE__*/_defineComponent({
  __name: 'ViewWrapper',
  props: {
    title: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  setup(__props) {

  // Vue
  const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", {
    id: props.id
  }, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(props.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 8, _hoisted_1))
}
}

})